module.exports = __webpack_public_path__ + "img/pic_location_Ecua_Quito.b7201df1.png";